"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionHandler = exports.SubscriptionHandlerError = exports.SubscriptionHandlerErrorTypes = void 0;
const rxjs_1 = require("rxjs");
const utilities_1 = require("@rxap/utilities");
var SubscriptionHandlerErrorTypes;
(function (SubscriptionHandlerErrorTypes) {
    SubscriptionHandlerErrorTypes["NOT_FOUND"] = "Subscription with specified key not found";
    SubscriptionHandlerErrorTypes["CLOSED"] = "Subscription with specified key is closed";
})(SubscriptionHandlerErrorTypes || (exports.SubscriptionHandlerErrorTypes = SubscriptionHandlerErrorTypes = {}));
class SubscriptionHandlerError extends Error {
    constructor(type, key) {
        super(type + ` [${key}]`);
        this.type = type;
        this.key = key;
        Object.setPrototypeOf(this, SubscriptionHandlerError.prototype);
    }
}
exports.SubscriptionHandlerError = SubscriptionHandlerError;
/**
 * Provide the same functionality as Subscription from rxjs.
 * With the extation that the subscriptions can be group added/unsubscribed
 *
 * @deprecated removed
 */
class SubscriptionHandler {
    constructor() {
        /**
         * A map of subscriptions
         *
         * @internal
         */
        this.subscriptions = new Map();
    }
    add(keyOrTeardown, teardown) {
        const key = typeof keyOrTeardown === 'string' ? keyOrTeardown : SubscriptionHandler.DEFAULT_KEY;
        teardown = typeof keyOrTeardown === 'string' ? teardown : keyOrTeardown;
        if (!this.subscriptions.has(key)) {
            this.subscriptions.set(key, new rxjs_1.Subscription());
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const subscription = this.subscriptions.get(key);
        if (subscription.closed) {
            throw new SubscriptionHandlerError(SubscriptionHandlerErrorTypes.CLOSED, key);
        }
        return subscription.add(teardown);
    }
    has(key) {
        return this.subscriptions.has(key);
    }
    get(key) {
        return this.subscriptions.get(key);
    }
    set(key, teardown) {
        if (this.has(key)) {
            this.reset(key);
        }
        return this.add(key, teardown);
    }
    /**
     * Disposes the resources held by the subscription. May, for instance, cancel
     * an ongoing Observable execution or cancel any other type of work that
     * started when the Subscription was created.
     *
     * @param key (optional) the target group of subscriptions
     */
    unsubscribe(key) {
        key = key || SubscriptionHandler.DEFAULT_KEY;
        const subscription = this.subscriptions.get(key);
        if (subscription) {
            this.subscriptions.delete(key);
            subscription.unsubscribe();
            return subscription;
        }
        throw new SubscriptionHandlerError(SubscriptionHandlerErrorTypes.NOT_FOUND, key);
    }
    /**
     * Disposes all the resources held by the subscription handler. May, for instance, cancel
     * an ongoing Observable execution or cancel any other type of work that
     * started when the Subscription was created.
     */
    unsubscribeAll() {
        return Array.from(this.subscriptions.keys())
            .map(key => ({ [key]: this.unsubscribe(key) }))
            .reduce(utilities_1.objectReducer, {});
    }
    /**
     * Resets the specified subscription group.
     * Each Subscription in the group will be unsubscribed before the new subscription
     * instance is created
     *
     * @param key (optional) the target group of subscriptions
     */
    reset(key) {
        key = key || SubscriptionHandler.DEFAULT_KEY;
        if (!key || this.has(key)) {
            this.unsubscribe(key);
        }
        this.subscriptions.set(key, new rxjs_1.Subscription());
    }
    resetAll() {
        Array.from(this.subscriptions.keys()).forEach(key => this.reset(key));
    }
}
exports.SubscriptionHandler = SubscriptionHandler;
/**
 * @internal
 */
SubscriptionHandler.DEFAULT_KEY = '__rxap_subscription_handler__';
